import { z } from 'zod/v4';
// Code category
export const CodeCategorySchema = z.enum([
    'service-type',
    'document-type',
    'court-type',
    'status-code',
    'billing-code',
    'workflow-trigger',
]);
// Code status
export const CodeStatusSchema = z.enum([
    'executed',
    'received',
    'inactive',
]);
// Code schema - business logic flags for low-code automation
export const CodeSchema = z.object({
    id: z.string().uuid(),
    code: z.string(), // Short unique code (e.g., "SRV-001", "DOC-SUMMONS")
    category: CodeCategorySchema,
    name: z.string(),
    description: z.string().optional(),
    // Status
    status: CodeStatusSchema.default('inactive'),
    // Service trigger flags (boolean matrix)
    // These determine what actions/services are triggered when this code is used
    filing: z.boolean().default(false),
    research: z.boolean().default(false),
    serve: z.boolean().default(false),
    courtesyCopy: z.boolean().default(false),
    countyRecorder: z.boolean().default(false),
    skipTrace: z.boolean().default(false),
    writService: z.boolean().default(false),
    stateFiling: z.boolean().default(false),
    eService: z.boolean().default(false),
    vendor: z.boolean().default(false),
    // Workflow settings
    autoApply: z.boolean().default(false), // Automatically apply based on conditions
    requiresApproval: z.boolean().default(false),
    notifyClient: z.boolean().default(false),
    // Conditions for auto-apply (JSON rules)
    conditions: z.object({
        orderTypes: z.array(z.string()).optional(),
        documentTypes: z.array(z.string()).optional(),
        locationCodes: z.array(z.string()).optional(),
        minAmount: z.number().optional(),
        maxAmount: z.number().optional(),
    }).optional(),
    // Pricing impact (optional fee adjustments)
    additionalFee: z.number().optional(),
    feeDescription: z.string().optional(),
    // Notes
    notes: z.string().optional(),
    internalNotes: z.string().optional(),
    // Display order
    sortOrder: z.number().default(0),
    // Timestamps
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateCodeSchema = CodeSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateCodeSchema = CodeSchema.partial().omit({
    id: true,
    createdAt: true,
});
// Code preview
export const CodePreviewSchema = z.object({
    id: z.string().uuid(),
    code: z.string(),
    category: CodeCategorySchema,
    name: z.string(),
    status: CodeStatusSchema,
    // Summary of active flags
    activeFlags: z.array(z.string()),
});
